import customAxios from './axios';
import CONFIG from '../../config';

export const getAllAdminJobs = (payload) => {
    return customAxios.post(CONFIG.apiURL + '/TypingcenterAdminReport/GetJobs', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const getAllStaffJobs = (payload) => {
    return customAxios.post(CONFIG.apiURL + '/TypingcenterStaffReport/GetJobs', payload).then(res => {
        let response = res['data'];
        return response;
    });
};
